// 注册
<template>
  <div class="register">
    <van-nav-bar @click-left="$router.go(-1)" left-arrow fixed placeholder :title="$t('register.forget')"></van-nav-bar>

    <section class="form">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.email"
          name="email"
          :placeholder="$t('placeholder.email')"
        />
        <van-field
          v-model="form.verificationCode"
          name="verificationCode"
          :placeholder="$t('placeholder.verifiy')"
        >
          <template #button>
            <div class="verify-btn" @click="getCode">{{ second < 60 ? `${second}s` : 'verification code' }}</div>
          </template>
        </van-field>
        <van-field
          v-model="form.newPassword"
          name="newPassword"
          type="password"
          :placeholder="$t('placeholder.newPassword')"
        />
        <van-field
          v-model="form.reNewPassword"
          name="reNewPassword"
          type="password"
          :placeholder="$t('placeholder.confirmPassword')"
        />
        <div style="margin: 24px 25px 0;">
          <van-button class="submit" block round size="large" color="linear-gradient(30deg, #3EE191, #24DEDD)" type="info" native-type="submit">
          {{ $t('register.confirm') }}
        </van-button>
        </div>
      </van-form>
    </section>
  </div>
</template>

<script>
import { getVerificationCode, updatePassword } from '@/api'
const count = 60
export default {
  name: 'Forget',
  data () {
    return {
      second: count,
      secondTimer: null,
      form: {
        email: '',
        verificationCode: '',
        newPassword: '',
        reNewPassword: ''
      },
    }
  },
  watch: {
    second (val) {
      if (val === 0) {
        clearInterval(this.secondTimer)
        this.secondTimer = null
        this.second = count
      }
    }
  },
  methods: {
    // 邮箱验证
    validatorEmail (value) {
      const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      return reg.test(value)
    },
    // 获取验证码
    getCode () {
      if (this.second < 60) {
        return
      }
      if (!this.form.email) {
        this.$toast(this.$t('placeholder.email'))
        return
      }
      this.$toast.loading({
        duration: 0
      })
      getVerificationCode({
        email: this.form.email,
        type: 2
      }).then(res => {
        this.$toast.success(res.msg)
        this.secondTimer = setInterval(() => {
          this.second--
        }, 1000)
      }).finally(() => {
        setTimeout(() => {
          this.$toast.clear()
        }, 2000)
      })
    },
    // 表单提交
    onSubmit () {
      if (!this.form.email) {
        this.$toast(this.$t('placeholder.email'))
        return
      } else {
        // 邮箱验证
        if (!this.validatorEmail(this.form.email)) {
          this.$toast(this.$t('placeholder.email'))
          return
        }
      }
      if (!this.form.verificationCode) {
        this.$toast(this.$t('placeholder.verifiy'))
        return
      }
      // if (!this.form.password) {
      //   this.$toast(this.$t('placeholder.password'))
      //   return
      // }
      updatePassword({
        email: this.form.email,
        verificationCode: this.form.verificationCode,
        imie: this.$store.state.app.imie,
        newPassword: this.$md5(this.form.newPassword).toUpperCase(),
        reNewPassword: this.$md5(this.form.reNewPassword).toUpperCase()
      }).then(res => {
        this.$toast.success(res.msg)
        this.$router.go(-1)
      })
    }
  }
}
</script>

<style lang="less">
  .register {
    box-sizing: border-box;
    min-height: 100vh;
    height: 100%;
    padding: 24px;
    .verify-btn {
      text-align: center;
      width: 180px;
      border: 1px solid #D2D2D2;
      color: #797979;
      font-size: 18px;
      background: transparent;
      padding: 10px 14px;
      border-radius: 40px;
    }
    .van-cell {
      background: transparent;
      padding: 30px 40px;
      &:after {
        border-color: #D2D2D2;
      }
    }
    .van-nav-bar {
      background: #fff!important;
      .van-nav-bar__title {
        color: #000;
        width: 80%;
        max-width: 80%;
        font-weight: normal!important;
      }
    }
    .van-field__label {
      color: #c8c9cc;
    }
  }
</style>
